<template>
  <div class="row h-100">
    <div class="col-12 h-100 d-flex flex-column">
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-6 mb-n2">
          <Select v-model="selectedYear" :on-change="() => init(selectedTab)" :options="yearOptions" form-group-id="Year" placeholder="year" />
        </div>
      </div>
      <div v-if="loaded" class="poppins planned-content overflow-hidden">
        <b-tabs
          v-model="selectedTab"
          pills
          card
          active-tab-class="p-0 d-flex flex-column"
          content-class="mt-3 pt-1 d-flex flex-column overflow-hidden"
          nav-wrapper-class="pt-0 pl-3"
          class="h-100 d-flex flex-column overflow-hidden"
        >
          <b-tab :title="'Table' | i18n" @click="selectedTab = 0">
            <div class="h-100 d-flex flex-column">
              <div class="row mb-4">
                <div v-if="data['1']" class="col-lg-12 col-sm-12 col-12 d-flex align-items-center justify-content-between pt-1">
                  <div class="d-flex">
                    <b-button variant="primary" size="lg" @click="exportToPDF" class="pdf-btn">
                      {{ 'PDF' | i18n }}
                    </b-button>
                    <b-button variant="primary" size="lg" @click="exportCSV" class="export-btn"> {{ 'export' | i18n }} CSV </b-button>
                  </div>
                  <div class="arrows-block">
                    <b-button variant="primary" size="lg" @click="scrollShift(-600)">
                      <BIconArrowLeft />
                    </b-button>
                    <b-button variant="primary" size="lg" @click="scrollShift(600)">
                      <BIconArrowRight />
                    </b-button>
                  </div>
                </div>
              </div>
              <div v-if="loadingTablePDF" class="table-pdf-loader">
                <Loader />
              </div>
              <div :class="`table-wrapper w-100 overflow-auto ${loadingTablePDF ? 'table-pdf-format' : ''}`" v-if="data['1']" id="pdf-element">
                <div class="table-title" v-if="loadingTablePDF">
                  <span> Monatswerte {{ selectedYear }} </span>
                  <span>
                    {{ moment().format('DD-MM-YYYY') }}
                  </span>
                </div>
                <table class="roboto-mono" ref="tableData">
                  <thead class="header">
                    <tr>
                      <th class="center">{{ this.selectedYear }}</th>
                      <th colspan="7" class="center">{{ 'Amount of waste delivered to the RMVA in t' | i18n }}</th>
                      <th class="center">Verbrennung</th>
                      <th class="center">Erdgasbezug</th>
                      <th class="center">Heizölverbr.</th>
                      <th class="center">Strombezug</th>
                      <th colspan="3" class="center">Energielieferung an RheinEnergie</th>
                      <th class="center">Rostasche</th>
                      <th class="center">Stäube</th>
                      <th class="center">Gips</th>
                      <th class="center">VSA-Schrott</th>
                      <th class="center">SpM von AWB</th>
                      <th class="center">S Stadt Köln</th>
                      <th class="center">SiWa-Konz.</th>
                    </tr>
                    <tr>
                      <th class="center">{{ 'Month' | i18n }}</th>
                      <th class="center">Stadt Köln Hausm.</th>
                      <th class="center">Stadt SpM-Rück</th>
                      <th class="center">Sonst.</th>
                      <th class="center">AVG-R</th>
                      <th class="center">REMONDIS</th>
                      <th class="center">Summe Sortier-Reste</th>
                      <th class="center">Summe gesamt</th>
                      <th class="center">in t</th>
                      <th class="center">in Nm³</th>
                      <th class="center">in Liter</th>
                      <th class="center">in MWh</th>
                      <th class="center">Strom<br />[MWh,el]</th>
                      <th class="center">Ferndampf<br />[MWh,th]</th>
                      <th class="center">Summe<br />[MWh,el]</th>
                      <th class="center">in t</th>
                      <th class="center">in t</th>
                      <th class="center">in t</th>
                      <th class="center">in t</th>
                      <th class="center">in t</th>
                      <th class="center">in t</th>
                      <th class="center">in t</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="`roboto-mono ${currentMonth === monthNameList[index] ? 'highlighted-month' : ''}`"
                      v-for="(month, index) in monthList"
                      :key="month"
                    >
                      <td class="roboto-mono center" width="10">
                        {{ monthNameList[index] | i18n }}
                      </td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(data[month][key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono sum-line">
                      <td class="sum-name center">
                        {{ 'Sum' | i18n }}
                      </td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(total[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name" />
                      <td colspan="2" class="roboto-mono text-center">
                        {{ format(total['Summe Stadt Köln Hausm and Stadt SpM-Rück']) }}
                      </td>
                      <td :colspan="plannedKeys.length - 2" class="roboto-mono" />
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name text-center">
                        <div>aktueller</div>
                        <div>Planwert</div>
                      </td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(planned.currentPlanValue[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name text-center">Delta</td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(planned.delta[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name" />
                      <td colspan="2" class="roboto-mono text-center">
                        {{ format(planned.delta['Summe Stadt Köln Hausm and Stadt SpM-Rück']) }}
                      </td>
                      <td :colspan="plannedKeys.length - 2" class="roboto-mono" />
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name text-center">Delta %</td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(planned.deltaPercentage[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name" style="color: white;border">-</td>
                      <td :colspan="plannedKeys.length" class="roboto-mono" />
                    </tr>
                    <tr class="roboto-mono">
                      <td :class="`light-name text-center ${loadingTablePDF ? 'small-font' : ''}`">
                        <div>Planwert</div>
                        <div>Ende</div>
                        <div>Vormonat</div>
                      </td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(planned.planValuePreviousMonth[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td :class="`light-name text-center ${loadingTablePDF ? 'small-font' : ''}`">
                        <div>Istwert</div>
                        <div>Ende</div>
                        <div>Vormonat</div>
                      </td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(totalPreviousMonth[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name text-center">Delta</td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(planned.deltaPreviousMonth[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name" />
                      <td colspan="2" class="roboto-mono text-center">
                        {{ format(planned.deltaPreviousMonth['Summe Stadt Köln Hausm and Stadt SpM-Rück']) }}
                      </td>
                      <td :colspan="plannedKeys.length - 2" class="roboto-mono" />
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name text-center">Delta %</td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(planned.deltaPercentagePreviousMonth[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name" style="color: white;border">-</td>
                      <td :colspan="plannedKeys.length" class="roboto-mono" />
                    </tr>
                    <tr class="roboto-mono">
                      <td :class="`light-name text-center ${loadingTablePDF ? 'small-font' : ''}`">Jahresplan</td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(annualPlan[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td :class="`light-name text-center ${loadingTablePDF ? 'small-font' : ''}`">Restmenge aktuell</td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(remainingAmountCurrently[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td :class="`light-name text-center ${loadingTablePDF ? 'small-font' : ''}`">Restmenge Vormonat</td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(remainderPreviousMonth[key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name" style="color: white;border">-</td>
                      <td :colspan="plannedKeys.length" class="roboto-mono" />
                    </tr>
                    <tr class="roboto-mono">
                      <td class="light-name center sum-name">{{ 'Month' | i18n }}</td>
                      <td :colspan="plannedKeys.length" class="roboto-mono center">
                        Delta-Werte zum Vorjahr (Wert {{ selectedYear }} minus Wert {{ selectedYear - 1 }})
                      </td>
                    </tr>
                    <tr
                      v-for="(month, index) in monthList"
                      :key="`${month}+lastDayInMonth`"
                      :class="`roboto-mono ${currentMonth === monthNameList[index] ? 'highlighted-month' : ''}`"
                    >
                      <td class="roboto-mono center">
                        {{ monthNameList[index] | i18n }}
                      </td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key">
                        {{ format(lastDayOfTheMonthStatistic[month][key]) }}
                      </td>
                    </tr>
                    <tr class="roboto-mono sum-line">
                      <td class="sum-name center">
                        {{ 'Sum' | i18n }}
                      </td>
                      <td class="roboto-mono" v-for="key in plannedKeys" :key="key + '-total'">
                        {{ format(lastDayOfTheMonthStatistic.total[key]) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="no-data">
                {{ 'no_table_data' | i18n }}
              </div>
            </div>
          </b-tab>
          <b-tab :title="'Diagrams' | i18n" @click="selectedTab = 1">
            <div class="overflow-auto">
              <div v-if="loadingTablePDF" class="table-pdf-loader">
                <Loader />
              </div>
              <div v-if="data['1']">
                <div class="chart-pdf-btn">
                  <b-button variant="primary" size="sm" @click="exportChartToPDF(1)">
                    {{ 'PDF' | i18n }}
                  </b-button>
                </div>
                <div :class="`${chartStyleForPDF ? 'chart-pdf-format' : 'chart-format'}`" id="pdf-chart-1">
                  <div class="table-title" v-if="chartStyleForPDF">
                    <span> Monatswerte {{ selectedYear }} </span>
                    <span>
                      {{ moment().format('DD-MM-YYYY') }}
                    </span>
                  </div>
                  <MonthlyChart
                    :month-name-list="monthNameList"
                    :data="data"
                    :visible-data-list="visibleDataListChart1"
                    v-if="!reloadChartAfterPDF"
                    :style="chartStyleForPDF ? chartStyle : null"
                  />
                </div>
                <div class="chart-pdf-btn">
                  <b-button variant="primary" size="sm" @click="exportChartToPDF(2)">
                    {{ 'PDF' | i18n }}
                  </b-button>
                </div>
                <div :class="`${chartStyleForPDF ? 'chart-pdf-format' : 'chart-format'}`" id="pdf-chart-2">
                  <div class="table-title" v-if="chartStyleForPDF">
                    <span> Monatswerte {{ selectedYear }} </span>
                    <span>
                      {{ moment().format('DD-MM-YYYY') }}
                    </span>
                  </div>
                  <MonthlyChart
                    :month-name-list="monthNameList"
                    :data="data"
                    :visible-data-list="visibleDataListChart2"
                    v-if="!reloadChartAfterPDF"
                    :style="chartStyleForPDF ? chartStyle : null"
                  />
                </div>
                <div class="chart-pdf-btn">
                  <b-button variant="primary" size="sm" @click="exportChartToPDF(3)">
                    {{ 'PDF' | i18n }}
                  </b-button>
                </div>
                <div :class="`${chartStyleForPDF ? 'chart-pdf-format' : 'chart-format'}`" id="pdf-chart-3">
                  <div class="table-title" v-if="chartStyleForPDF">
                    <span> Monatswerte {{ selectedYear }} </span>
                    <span>
                      {{ moment().format('DD-MM-YYYY') }}
                    </span>
                  </div>
                  <MonthlyChart
                    :month-name-list="deltaStadt.legend"
                    :data="deltaStadt"
                    :visible-data-list="visibleDataListChart3"
                    :isYearChart="true"
                    v-if="!reloadChartAfterPDF"
                    :style="chartStyleForPDF ? chartStyle : null"
                  />
                </div>
              </div>
              <div v-else class="no-data">
                {{ 'no_table_data' | i18n }}
              </div>
            </div>
          </b-tab>
          <b-tab :title="'KPI' | i18n" @click="selectedTab = 2">
            <div>
              <b-card-group deck>
                <b-card
                  bg-variant="primary"
                  header-bg-variant="primary"
                  text-variant="white"
                  :header="'During the last 30 days' | i18n"
                  class="text-center kpi-desc"
                >
                  <b-card-text v-if="kpi['last30Days'] !== undefined"> {{ format(kpi['last30Days'] / 30) }}t </b-card-text>
                  <b-card-text v-else>
                    {{ '-' }}
                  </b-card-text>
                </b-card>

                <b-card
                  bg-variant="secondary"
                  header-bg-variant="secondary"
                  text-variant="white"
                  :header="'During the last 60 days' | i18n"
                  class="text-center kpi-desc"
                >
                  <b-card-text v-if="kpi['last60Days'] !== undefined"> {{ format(kpi['last60Days'] / 60) }}t </b-card-text>
                  <b-card-text v-else>
                    {{ '-' }}
                  </b-card-text>
                </b-card>

                <b-card
                  bg-variant="success"
                  header-bg-variant="success"
                  text-variant="white"
                  :header="'During the last 90 days' | i18n"
                  class="text-center kpi-desc"
                >
                  <b-card-text v-if="kpi['last90Days'] !== undefined"> {{ format(kpi['last90Days'] / 90) }}t </b-card-text>
                  <b-card-text v-else>
                    {{ '-' }}
                  </b-card-text>
                </b-card>

                <b-card
                  bg-variant="warning"
                  header-bg-variant="warning"
                  text-variant="white"
                  :header="'During the current year' | i18n"
                  class="text-center kpi-desc"
                >
                  <b-card-text v-if="kpi['currentYear'] !== undefined"> {{ format(kpi['currentYear'] / 365) }}t </b-card-text>
                  <b-card-text v-else>
                    {{ '-' }}
                  </b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <Loader v-else />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { BTabs, BTab, BCardGroup, BCard, BCardText, BIconArrowRight, BIconArrowLeft } from 'bootstrap-vue';
import html2pdf from 'html2pdf.js';

import api from '../../../api';

import Input from '../../common/input';
import Select from '../../common/select';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';
import MonthlyChart from './components/monthly-chart';

const currentYear = Number(moment().format('YYYY'));

export default {
  title: 'MonthlyValues',
  components: {
    'b-tabs': BTabs,
    'b-tab': BTab,
    'b-card-group': BCardGroup,
    'b-card': BCard,
    'b-card-text': BCardText,
    Input,
    Loader,
    BlockHeader,
    Select,
    MonthlyChart,
    BIconArrowRight,
    BIconArrowLeft,
  },
  data() {
    return {
      chartStyle: {
        height: `700px`,
        position: 'relative',
      },
      loadingTablePDF: false,
      reloadChartAfterPDF: false,
      chartStyleForPDF: false,
      selectedTab: 0,
      loaded: false,
      isSaving: false,
      selectedYear: currentYear,
      yearOptions: [],
      monthList: Array.from({ length: 12 }, (_, i) => i + 1),
      monthNameList: moment.monthsShort(),
      data: {},
      deltaStadt: {},
      lastDayOfTheMonthStatistic: {},
      total: {},
      totalPreviousMonth: {},
      planned: {},
      annualPlan: {},
      remainderPreviousMonth: {},
      remainingAmountCurrently: {},
      kpi: {},
      moment,
      currentMonth: moment().format('MMM'),
      plannedKeys: [
        'Stadt Köln Hausm',
        'Stadt SpM-Rück',
        'Sonst',
        'AVG-R',
        'REMONDIS',
        'Summe Sortier-Reste',
        'Summe gesamt',
        'Verbrennung',
        'Erdgasbezug',
        'Heizölverbr',
        'Strombezug',
        'Strom',
        'Ferndampf',
        'Summe',
        'Rostasche',
        'Stäube',
        'Gips',
        'VSA-Schrott',
        // not implemented
        'SpM von AWB',
        'S Stadt Köln',
        'SiWa-Konz.',
        //
      ],
      visibleDataListChart1: [
        { label: 'Stadt Köln Hausm.', key: 'Stadt Köln Hausm' },
        { label: 'Stadt SpM-Rück', key: 'Stadt SpM-Rück' },
        { label: 'AVG-R', key: 'AVG-R' },
        { label: 'REMONDIS', key: 'REMONDIS' },
        { label: 'Summe Sortier-Reste', key: 'Summe Sortier-Reste' },
        { label: 'Summe gesamt', key: 'Summe gesamt' },
      ],
      visibleDataListChart2: [
        { label: 'Summe gesamt', key: 'Summe gesamt' },
        { label: 'Ver-brennung', key: 'Verbrennung' },
      ],
      visibleDataListChart3: [
        { label: 'Stadt Köln, gesamt', key: 'Stadt Köln, gesamt' },
        { label: 'Stadt Köln Hausmüll', key: 'Stadt Köln Hausmüll' },
        { label: 'Stadt Köln Sperrmüll', key: 'Stadt Köln Sperrmüll' },
        { label: 'Stadt Köln zur RMVA', key: 'Stadt Köln zur RMVA' },
      ],
    };
  },

  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.init();
  },
  methods: {
    exportToPDF() {
      this.loadingTablePDF = true;
      setTimeout(() => {
        const element = document.getElementById('pdf-element');
        var opt = {
          margin: 0,
          filename: `monthly_values_${this.selectedYear}.pdf`,
          html2canvas: { scale: 4 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
        };
        html2pdf().from(element).set(opt).save();
        this.loadingTablePDF = false;
      }, 1000);
    },
    exportChartToPDF(number) {
      this.loadingTablePDF = true;
      this.chartStyleForPDF = true;
      setTimeout(() => {
        const element = document.getElementById(`pdf-chart-${number}`);
        var opt = {
          margin: 0,
          filename: `chart_${number}_${this.selectedYear}.pdf`,
          html2canvas: { scale: 4 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
        };
        html2pdf().from(element).set(opt).save();
        this.reloadChartAfterPDF = true;
        this.chartStyleForPDF = false;
        setTimeout(() => {
          this.reloadChartAfterPDF = false;
          this.loadingTablePDF = false;
        }, 1000);
      }, 1000);
    },
    scrollShift(offset) {
      document.querySelector('.table-wrapper').scrollLeft += offset;
    },
    format(n) {
      if (isNaN(n)) {
        return '';
      }
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(n);
    },
    async init(lastSelectedTab) {
      try {
        localStorage.setItem('selectedYear', this.selectedYear);
        this.loaded = false;
        const response = await api.monthlyValues.get({ year: this.selectedYear });
        this.data = response.data;
        this.deltaStadt = response.deltaStadt;
        this.lastDayOfTheMonthStatistic = response.lastDayOfTheMonthStatistic;
        this.total = response.total;
        this.totalPreviousMonth = response.totalPreviousMonth;
        this.planned = response.planned;
        this.annualPlan = response.annualPlan;
        this.remainderPreviousMonth = response.remainderPreviousMonth;
        this.remainingAmountCurrently = response.remainingAmountCurrently;
        this.kpi = response.kpi;
        this.loaded = true;
        if (lastSelectedTab) this.selectedTab = lastSelectedTab;
      } catch (e) {
        this.data = [];
        this.loaded = true;
        this.kpi = {};
        if (lastSelectedTab) this.selectedTab = lastSelectedTab;
      }
    },
    exportCSV() {
      const table = this.$refs.tableData;

      const rows = table.getElementsByTagName('tr');
      const csvData = [...rows].map((row) => {
        const cols = row.querySelectorAll('td,th');
        const csvRow = [...cols].map((col) => {
          let data = col.innerText;
          data = data.split('\n').join(' ');
          if (data.includes(',')) {
            data = `"${data}"`;
          }
          if (col.colSpan > 1) {
            const colSpanArr = [...Array(col.colSpan - 1).keys()].map(() => ';');
            data = [data, ...colSpanArr].join('');
          }
          return data;
        });
        return csvRow.join(';');
      });
      const csvFinalData = csvData.join('\n');

      const csvFile = new Blob(['\uFEFF' + csvFinalData], { type: 'text/csv; charset=utf-8' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(csvFile);
      link.download = 'monthly_values';
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
}
::v-deep .card-header {
  background: white;
}
::v-deep .card-text {
  font-size: 1.5rem;
}
.kpi-desc {
  max-width: 200px;
  & > .card-header {
    font-size: 1.2rem;
    line-height: 1.5em;
    height: 6em;
    display: flex;
    align-items: center;
  }
}
.line-value {
  display: flex;
  margin-left: 20px;
  align-items: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  margin-top: 20px;
  padding: 10px;
}

.type-value {
  margin-left: 10px;
  width: 90px;
}

table,
td,
th {
  box-shadow: inset 0 0 0 1px #333;
  background: white;
}

th {
  padding: 5px;
  font-size: 14px;
  text-align: right;
}

td {
  padding: 5px;
  text-align: right;
}

tr th:first-child,
tr td:first-child {
  position: sticky;
  left: 0;
}

.sum-name {
  font-weight: 700;
  font-size: 14px;
}

.light-name {
  font-size: 14px;
}

.no-data {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rotate-header {
  -ms-writing-mode: tb-rl;
  -webkit-writing-mode: vertical-rl;
  -moz-writing-mode: vertical-rl;
  -ms-writing-mode: vertical-rl;
  writing-mode: vertical-rl;
  transform: rotate(-180deg);
  white-space: nowrap;
  height: 330px;
  position: absolute;
  top: -5px;
  display: flex;
  align-items: center;
  width: 100%;
  right: 1px;
}
.center {
  text-align: center;
}

.highlighted-month td {
  background: rgb(177, 207, 149);
}

.header {
  position: sticky;
  top: 0;
  z-index: 1;
}

.header th {
  background: #f2f2f2;
}

.sum-line td {
  background: #f2f2f2;
  font-weight: 700;
}

.arrows-block {
  margin-left: 50px;
  display: flex;
  width: 90px;
  justify-content: space-between;
}

.export-btn {
  display: block;
}

.pdf-btn {
  margin-right: 15px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 30px;
}

.chart-pdf-format {
  height: 794px;
  font-size: 10px !important;
  width: 1125px !important;
  display: flex;
  padding: 20px;
  flex-direction: column;
  div {
    width: 100%;
  }
}

.chart-format {
  height: 400px;
  flex-direction: column;
}

.table-pdf-format {
  height: 794px;
  font-size: 10px !important;
  width: 1125px !important;
  display: flex;
  padding: 15px;
  flex-direction: column;
  table {
    table-layout: fixed;
    width: 100%;
    flex: 1;
  }

  td {
    overflow-wrap: break-word;
    padding: 0 5px;
    font-size: 8px !important;
  }
  th {
    font-size: 5.5px !important;
    overflow-wrap: break-word;
    padding: 0 5px;
    text-align: center;
    height: 25px;
  }
  .light-name {
    font-size: 8px !important;
  }
  .sum-name {
    font-size: 8px !important;
  }

  .small-font {
    font-size: 5px !important;
  }
  .medium-font {
    font-size: 6.5px !important;
  }
}

.table-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.table-pdf-loader {
  background: white;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.chart-pdf-btn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
</style>
